// Copy and photos for the laser cutting and CNC routing pages
// (CuttingServicePage.js), in the laser engraving design family:
//   laser     /services/laser-cutting/       national laser cutting
//   laserNyc  /laser-cutting-service-nyc/    NYC laser cutting (was Contentful)
//   cnc       /services/cnc-routing/         national CNC routing
//   cncLarge  /cnc-routing-service/          5 × 10 ft large-format CNC (was
//                                            Contentful)
// Facts come from .seo/truth.md (laser and CNC rows) and the pages these
// replace: the Epilog Fusion M2 laser, its 40 × 28 in work area and 1/4 in
// acrylic and wood cuts are from the old NYC page. No price, minimum or
// turnaround is published for either machine, so those are "quoted per
// project". The old pages' same-day cutting, $65 design service, student
// discount and $300–$3,000 CNC range aren't in truth.md and are left out.
// Photos are the old pages' Contentful images and the laser cutting and
// architecture albums; captions carry no client or artist names.
const photoRoot = 'https://images.ctfassets.net/dovsnf6qrcem'
const reviewedDate = '2026-11-04'

const facts = {
  laser: {
    machine: 'Epilog Fusion M2',
    workArea: '40 × 28 in',
    workAreaWords: '40 by 28 inches',
    thickness: '1/4 in',
    files: 'AI, SVG, EPS, DWG, DXF or 3DM',
  },
  cnc: {
    bed: '5 × 10 ft',
    bedWords: '5 by 10 feet',
    files: 'STP (STEP) or vector files such as AI or DXF',
  },
  modelingFrom: 250,
  studios:
    'Glendale, Queens (74-12 88th Street) and Brooklyn (616 Berriman Street)',
  paths: {
    laser: '/services/laser-cutting/',
    laserNyc: '/laser-cutting-service-nyc/',
    cnc: '/services/cnc-routing/',
    cncLarge: '/cnc-routing-service/',
  },
}

const photos = {
  layering: {
    url: `${photoRoot}/6l2V4O9wHeEycKAS0KCMwA/2d577f50346806f2abc1616c1203b46b/laser_cut_architecture_layering.jpg`,
    width: 5472,
    height: 3648,
    alt: 'A white architectural model of curved buildings built from stacked laser-cut layers',
    title: 'Layered architectural model',
    caption: 'Hundreds of laser-cut layers stacked into curved forms.',
  },
  hexModel: {
    url: `${photoRoot}/6qhpLL6oiGdKtEA5wwWJ0d/b49b394fda637d95692891ec000154bf/IMG_9933.JPG`,
    width: 3024,
    height: 3024,
    alt: 'A site model of hexagonal towers made from laser-cut card and board',
    title: 'Hexagon site model',
    caption: 'Card and board parts cut, scored and folded into a site model.',
  },
  perforated: {
    url: `${photoRoot}/4Emkp6cAijdLoYlKBQvJbt/d1bec2424702b2d7f2dedb97a629df1d/IMG_9924.JPG`,
    width: 4032,
    height: 3024,
    alt: 'A laser-cut architectural model with perforated roof panels and red scale figures',
    title: 'Perforated roof study',
    caption: 'Fine perforations cut into card for a daylight study.',
  },
  laserCutter: {
    url: `${photoRoot}/5rmA07hdZOAHJ4W1FYgtIm/a36ebdb650a51bee3e18e791cc63cbcc/Lasercutter.jpg`,
    width: 3648,
    height: 2736,
    alt: 'The Epilog Fusion M2 laser cutter in the PrintAWorld studio',
    title: 'Our Epilog Fusion M2',
    caption: 'The laser we cut on: a 40 × 28 in work area.',
  },
  crate: {
    url: `${photoRoot}/283zBWpBHR2y4sSlMMiiSV/c7fdf914865de159c06bfa15fd5688bd/DSC9468HR.jpg`,
    width: 7360,
    height: 4912,
    alt: 'A laser-cut crate sculpture on a gallery floor, with paintings on the walls',
    title: 'Crate for a gallery show',
    caption: 'A laser-cut crate made for an artist’s installation.',
  },
  figure: {
    url: `${photoRoot}/15pcCWDnNay4LY8Eai547E/bb385818d96c46964f36192c4016ef24/DSC9470LR__1_.jpg`,
    width: 801,
    height: 1200,
    alt: 'A flat cut-out figure hanging in a white gallery',
    title: 'Cut-out figure',
    caption: 'Flat cut panels hung in a gallery installation.',
  },
  boatHouse: {
    url: `${photoRoot}/3hJXqgUTWcqb1JaJf0135E/b3c55710818043669c559937e6e77393/WechatIMG919.jpeg`,
    width: 1080,
    height: 810,
    alt: 'An architectural model of a boat house with a lattice roof on a contoured base',
    title: 'Boat house model',
    caption:
      'A lattice roof and a contoured site base for an architecture model.',
  },
  boatHouseSide: {
    url: `${photoRoot}/5xZO7xhcaCioOKdxDmo6RX/8640004e963a1728ffaf876f6c224b01/WechatIMG920.jpeg`,
    width: 1080,
    height: 781,
    alt: 'Side view of an architectural model with stacked contour layers and a lattice roof',
    title: 'Contoured site base',
    caption: 'Stacked contour layers carry the terrain under the building.',
  },
  boatHouseEntry: {
    url: `${photoRoot}/3dITE2p4H0sKCxfdPF2rqX/0e3a8aea1361af855390edc93a9368d1/WechatIMG916.jpeg`,
    width: 1080,
    height: 678,
    alt: 'Close view of an architectural model entrance under a curved lattice roof',
    title: 'Lattice roof detail',
    caption: 'A curved lattice roof over the model’s entrance.',
  },
  window: {
    url: `${photoRoot}/1G7e940YcQKsR9JO9emb8j/876211c12afc949d56e2d7fc9a5199f8/IMG_2852.JPG`,
    width: 1440,
    height: 1080,
    alt: 'A retail window display with large ICE letters and a robot figure',
    title: 'Retail window display',
    caption: 'Display letters and props for a store window.',
  },
  panelArt: {
    url: `${photoRoot}/gJgHlBLphIbUaov513xqh/b5527fefef1a974513d29f049593803b/SELF-2017029-Keeper-1-LR-2.jpg`,
    width: 801,
    height: 1200,
    alt: 'A cut-out artwork panel shown on a white gallery wall',
    title: 'Cut-out artwork panel',
    caption: 'A shaped panel made for an artist’s show.',
  },
}

// Shared fact-sheet rows.
const studioRows = [
  ['Studios', facts.studios],
  ['Visits', 'By appointment. Confirm the studio and time before you come.'],
  ['Production', 'In-house, in our New York studios'],
  ['Price', 'Quoted per project, after a person reviews your file'],
  ['Turnaround', 'Confirmed in your quote. Tell us your date up front.'],
]

const laserMaterials = [
  {
    label: '01 / ACRYLIC',
    title: 'Acrylic signs, letters and parts',
    body: 'Opaque, translucent, transparent and mirrored acrylic for signs, displays, jewelry parts, enclosures, keychains and charms. We cut acrylic up to 1/4 in thick.',
  },
  {
    label: '02 / WOOD',
    title: 'Wood, plywood and MDF',
    body: 'Basswood, birch plywood, veneer, hardboard and MDF for models, panels, inlays and layered pieces. Wood cuts up to 1/4 in thick; we can engrave it in the same job.',
  },
  {
    label: '03 / PAPER & CARD',
    title: 'Card stock, museum board, chipboard',
    body: 'Paper, card stock, museum board, chipboard and cardboard for architectural models, packaging, stencils and invitations. Score lines fold cleanly.',
  },
]

const laserSteps = [
  {
    title: 'Send your file',
    body: `An ${facts.laser.files} vector file, with cut, score and engrave lines on separate layers or colors. No vector yet? Send a sketch or reference and we quote the file prep.`,
  },
  {
    title: 'Tell us the material',
    body: 'Material, color and thickness, finished size and quantity. Say whether we should source the sheets or you’ll supply approved stock.',
  },
  {
    title: 'Get a written quote',
    body: 'A person checks the file, the fit on our 40 × 28 in bed and the material, then sends the price and date. Nothing is cut until you approve it.',
  },
  {
    title: 'Pick up or get it shipped',
    body: 'Collect by appointment in Glendale, Queens or Brooklyn, send a courier, or have the parts packed and shipped anywhere in the U.S.',
  },
]

const cncMaterials = [
  {
    label: '01 / WOOD & MDF',
    title: 'Wood, plywood and MDF',
    body: 'Sheet goods and solid wood for signs, furniture parts, wall panels and 3D carvings.',
  },
  {
    label: '02 / FOAM & PLASTICS',
    title: 'HDU foam, plastics, laminate',
    body: 'High-density urethane (HDU) sign foam, plastics and high-pressure laminate for signs, props, displays and panels.',
  },
  {
    label: '03 / ALUMINUM',
    title: 'Aluminum, after review',
    body: 'Aluminum plates and parts are reviewed for grade, thickness and tooling before we quote.',
  },
]

const cncSteps = [
  {
    title: 'Send your CAD file',
    body: 'An STP (STEP) file for 3D carving, or a vector file such as AI or DXF for 2D cutting. Only have an image? We can model it first.',
  },
  {
    title: 'Choose the material',
    body: 'Material, grade and thickness, finished size, quantity and any pockets, engraving or 3D surfaces. Tell us the edge and surface finish you need.',
  },
  {
    title: 'Get a written quote',
    body: 'A person checks the file, the fit on our 5 × 10 ft bed, hold-down and tooling, then confirms the price and schedule. Routing starts once you approve and pay.',
  },
  {
    title: 'Pick up or get it shipped',
    body: 'Collect by appointment at the studio in your quote, or have the parts packed and shipped anywhere in the U.S.',
  },
]

const cncUses = [
  'Signs and lettering',
  'Art fabrication',
  'Furniture parts',
  'Custom props',
  'Architectural and interior parts',
  'Relief carving',
  'Decorative wall panels',
]

const pages = {
  laser: {
    path: facts.paths.laser,
    crumb: 'Laser cutting',
    serviceName: 'Custom laser cutting services',
    serviceType: 'Laser cutting, scoring and engraving',
    title: 'Laser Cutting Services | Custom Acrylic, Wood & Paper',
    description:
      'Custom laser cutting for acrylic, wood, paper and card on a 40 × 28 in bed, up to 1/4 in thick. Send a vector file for a quote; we ship across the U.S.',
    eyebrow: 'Laser cutting service · Cut in New York, shipped across the U.S.',
    heading: 'Custom Laser Cutting Services',
    answer:
      'PrintAWorld is a laser cutting service for businesses, brands, architects and artists. We cut, score and engrave acrylic, wood, paper and card on an Epilog Fusion M2 laser with a 40 × 28 inch work area, cutting acrylic and wood up to 1/4 inch thick. Send an AI, SVG, DXF or DWG file and a person quotes it. We cut in-house in New York, then you pick up by appointment or we ship anywhere in the U.S.',
    hero: 'layering',
    reviewedDate,
    introEyebrow: 'Custom laser cutting',
    introTitle: 'What is a laser cutting service?',
    intro: [
      'You send a vector file; we cut it from sheet material on our laser. The laser follows your lines to cut parts out, score fold lines, or engrave a mark, so you get finished flat parts without buying or running a machine.',
      'A person reviews every job. We check the file, the material and how the parts fit on the bed, tell you if anything needs fixing, and quote before we cut. We cut architectural models, acrylic signs and displays, parts for art installations and short runs for brands.',
    ],
    glanceTitle: 'Our laser cutting service at a glance',
    glance: [
      ['Laser', 'Epilog Fusion M2'],
      [
        'Work area',
        '40 × 28 in. The usable area depends on the sheet, thickness and design.',
      ],
      ['Cut thickness', 'Acrylic and wood up to 1/4 in'],
      ['Operations', 'Cut, score and engrave, in one job if you need'],
      [
        'Materials',
        'Acrylic, wood, plywood, MDF, paper, card stock, museum board, chipboard and cardboard. Other materials after a test.',
      ],
      ['Files', `${facts.laser.files} vector files`],
      ['Sheet material', 'We source it, or you supply approved stock'],
      [
        'Delivery',
        'Pickup by appointment in New York, or shipping anywhere in the U.S.',
      ],
      ...studioRows,
      ['Bigger or thicker?', 'CNC routing on a 5 × 10 ft bed'],
    ],
    workTitle: 'Laser cutting projects from our studio.',
    work: ['hexModel', 'crate', 'figure'],
    materialsTitle: 'What materials can we laser cut?',
    materials: laserMaterials,
    materialsNote:
      'Need leather, Delrin, stone, or glass etching? Tell us the exact product and we’ll test it. Some materials can’t be laser cut safely, so please don’t ship material until we approve it in writing.',
    contrast: {
      eyebrow: 'Too big or too thick for the laser?',
      title: 'Bigger than 40 × 28 in? Route it on our CNC.',
      body: [
        'Our laser cuts sheets up to 40 × 28 in and acrylic or wood up to 1/4 in thick. For thicker stock, full sheets, aluminum or 3D carving, our CNC router takes material up to 5 × 10 ft.',
      ],
      link: { to: facts.paths.cnc, text: 'Explore CNC routing' },
      secondary: {
        to: facts.paths.cncLarge,
        text: 'Large-format CNC, 5 × 10 ft bed ↗',
      },
    },
    stepsTitle: 'How does our laser cutting service work?',
    steps: laserSteps,
    optionsTitle: 'Where can you get something laser cut?',
    options: [
      {
        label: 'O1',
        title: 'A makerspace or school laser',
        body: 'Rent time on a laser and cut it yourself after a short class. Cheapest for a few small parts, if the bed and the wait suit you.',
      },
      {
        label: 'O2',
        title: 'An instant-quote website',
        body: 'Upload a file, pick from a stock material list and wait for shipping. Good for standard flat parts; file help and finishing usually aren’t included.',
      },
      {
        label: 'O3',
        title: 'A laser cutting studio, like ours',
        body: 'A person checks the file and the material, can cut, score and engrave in one job, and quotes before cutting. Best for models, signs, displays and brand work.',
      },
    ],
    fit: {
      good: [
        'Architectural models in chipboard, museum board, basswood or acrylic',
        'Acrylic signs, letters, displays and event pieces for brands and agencies',
        'Parts for art installations and gallery shows',
        'Flat prototypes, enclosures, stencils and layered pieces',
        'Short runs of the same part, cut and engraved',
      ],
      other: [
        'Running the laser yourself: a makerspace rents laser time',
        'Cutting steel or other sheet metal: a metal fabrication shop',
        'A single cheap hobby piece: a library or online marketplace costs less',
        'Stock over 1/4 in thick or bigger than 40 × 28 in: our CNC routing',
      ],
    },
    pricingTitle: 'How much does laser cutting cost?',
    pricingLabel: 'Laser cutting',
    prices: [
      ['Laser cutting and engraving', 'Quoted per project'],
      ['Sheet material', 'We source it, or you supply it'],
      ['File preparation from a sketch', 'Quoted per project'],
      ['Rush', 'Ask; not a standard promise'],
    ],
    pricingNote:
      'The price depends on the material and thickness, how many sheets the parts need, cutting and engraving time, file preparation, quantity, packing, delivery and your date. Send the file and we’ll reply with a price; it costs nothing to ask.',
    reviews: 'laser-cutting',
    handoffEyebrow: 'Shipping & pickup',
    handoffTitle: 'Where can you get your laser-cut parts?',
    handoff:
      'We cut in-house in New York and ship anywhere in the U.S., packed flat for the parts. Working in the city? Pick up by appointment at the studio named in your quote, in Glendale, Queens or Brooklyn.',
    timingTitle: 'Start with your date.',
    timing:
      'Turnaround depends on the file, material, quantity and finishing, so your quote confirms the date. Tell us when you need the parts in hand; rush work is reviewed job by job, not promised.',
    faqTitle: 'What do people ask about laser cutting?',
    faqs: [
      {
        question: 'How much does laser cutting cost?',
        answer:
          'Laser cutting is quoted per project. The price depends on the material and thickness, how many sheets your parts need, cutting and engraving time, file preparation, quantity, packing, delivery and deadline. Send your vector file with the material and quantity, and a person replies with a written price. Asking costs nothing.',
      },
      {
        question: 'What materials can you laser cut?',
        answer:
          'Acrylic (opaque, translucent, transparent and mirrored), wood, basswood, birch plywood, veneer, hardboard, MDF, paper, card stock, museum board, chipboard and cardboard. Other materials, such as leather, Delrin or stone, are tested first. Some materials can’t be laser cut safely, so we approve the exact product before you send it.',
      },
      {
        question: 'How big and how thick can you laser cut?',
        answer:
          'Our Epilog Fusion M2 has a 40 × 28 inch work area and cuts acrylic and wood up to 1/4 inch thick. The usable area depends on the sheet, thickness and design. For bigger or thicker parts, our CNC router takes stock up to 5 × 10 feet.',
      },
      {
        question: 'What file do I need for laser cutting?',
        answer:
          'A vector file: AI, SVG, EPS, DWG, DXF or 3DM, drawn at full size, with cut, score and engrave lines on separate layers or colors. If you only have a sketch, photo or PDF, we can prepare the file; that work is quoted with the job.',
      },
      {
        question: 'Do you provide the material?',
        answer:
          'Either way works. We can source the sheets and include them in the quote, or you can supply approved material. Send the exact product, thickness and a link first; we confirm it in writing before you ship or drop it off.',
      },
      {
        question: 'Can you laser cut metal?',
        answer:
          'Our laser doesn’t cut steel or other sheet metal; a metal fabrication shop is the better fit for that. Aluminum parts can be reviewed for our CNC router, and logos or text on metal objects go through our metal engraving service.',
      },
      {
        question: 'Can you cut and engrave in the same job?',
        answer:
          'Yes. The laser can cut parts out, score fold lines and engrave marks in one run. Put each operation on its own layer or color in the file and tell us which is which.',
      },
      {
        question: 'How long does laser cutting take?',
        answer:
          'It depends on the file, material, quantity and finishing, so your written quote confirms the date. Tell us when you need the parts in hand when you ask. Rush work is reviewed job by job; it isn’t a standard promise.',
      },
      {
        question: 'Do you ship laser-cut parts?',
        answer:
          'Yes, anywhere in the U.S. We pack the parts flat and quote shipping to your ZIP code with the job. In New York you can also pick up by appointment in Glendale, Queens or Brooklyn.',
      },
      {
        question: 'Is a laser cutting studio right for one small hobby piece?',
        answer:
          'Usually not. We work with businesses, brands, architects and artists, and a person reviews every job, so we cost more than a makerspace. For one small hobby part, a library or makerspace laser, or an online marketplace, will usually be cheaper.',
      },
    ],
    quoteTitle: ['Send us your file.', 'We’ll send a price.'],
    quoteIntro:
      'You don’t need to know laser settings. Send the file or a sketch, the material and how many you need, and we’ll reply with a price and next steps.',
    checklist: [
      'Vector file (AI, SVG, EPS, DWG, DXF or 3DM), at full size',
      'Material, color and thickness',
      'Finished size and quantity',
      'Which lines cut, score or engrave',
      'Who supplies the material',
      'Deadline and delivery ZIP code',
    ],
    related: [
      [facts.paths.laserNyc, 'Laser cutting in NYC'],
      [facts.paths.cnc, 'CNC routing'],
      [facts.paths.cncLarge, 'Large-format CNC, 5 × 10 ft'],
      ['/services/laser-engraving/', 'Laser engraving'],
    ],
    planner: 'laser',
  },

  laserNyc: {
    path: facts.paths.laserNyc,
    crumb: 'New York City',
    parent: 'laser',
    serviceName: 'Laser cutting service in NYC',
    serviceType: 'Laser cutting, scoring and engraving',
    local: true,
    title: 'Laser Cutting Service NYC | Acrylic & Wood, 40×28 in Bed',
    description:
      'Laser cutting in NYC: acrylic, wood, paper and card on a 40 × 28 in Epilog bed. Send an AI, SVG or DXF file. Pick up in Queens or Brooklyn, or we ship.',
    eyebrow: 'Laser cutter in Queens & Brooklyn, New York',
    heading: 'Laser Cutting Service in NYC',
    answer:
      'PrintAWorld is a laser cutting service in NYC, with studios in Glendale, Queens and Brooklyn. We cut, score and engrave acrylic, wood, paper and card on an Epilog Fusion M2 laser with a 40 × 28 inch bed, up to 1/4 inch thick in acrylic and wood. Send your vector file and get a written quote, then drop off approved material and pick up by appointment, send a courier, or have the parts shipped.',
    hero: 'perforated',
    reviewedDate,
    introEyebrow: 'Laser cutting near you',
    introTitle: 'What does our NYC laser cutting service cut?',
    intro: [
      'Architectural models are a specialty: site and massing models in chipboard and museum board, basswood and acrylic layers, and perforated card for light studies, for firms and architecture students alike.',
      'We also cut acrylic signs, letters and display pieces for brands and agencies, flat prototypes and stencils, and parts for artists’ installations, and we can engrave the same pieces in one run.',
      'There’s no walk-up counter: send the file first, a person checks it and quotes, and you drop off or collect by appointment in Glendale, Queens or Brooklyn.',
    ],
    glanceTitle: 'Laser cutting NYC at a glance',
    glance: [
      ['Studios', facts.studios],
      ['Visits', 'By appointment. Send your file first, then book a time.'],
      ['Laser', 'Epilog Fusion M2, cut in-house in New York'],
      [
        'Bed size',
        '40 × 28 in. The usable area depends on the sheet, thickness and design.',
      ],
      ['Cut thickness', 'Acrylic and wood up to 1/4 in'],
      ['Operations', 'Cut, score and engrave'],
      [
        'Materials',
        'Acrylic, wood, plywood, MDF, card stock, museum board, chipboard and cardboard. Other materials after a test.',
      ],
      ['Files', `${facts.laser.files} vector files`],
      [
        'Your own material',
        'Welcome once we approve the exact product in writing',
      ],
      [
        'Pickup & delivery',
        'Pickup by appointment, your courier, or shipping anywhere in the U.S.',
      ],
      ['Price', 'Quoted per project, after a person reviews your file'],
      ['Turnaround', 'Confirmed in your quote. Tell us your date up front.'],
      ['Bigger or thicker?', 'CNC routing on a 5 × 10 ft bed'],
    ],
    workTitle: 'Laser cutting in New York, from our studio.',
    work: ['laserCutter', 'layering', 'crate'],
    materialsTitle: 'Which materials can we laser cut in New York?',
    materials: laserMaterials,
    materialsNote:
      'Bringing your own sheets? Send the exact product, thickness and a link first. We approve it in writing before you drop it off, because some materials can’t be laser cut safely.',
    contrast: {
      eyebrow: 'Too big or too thick for the laser?',
      title: 'Bigger than 40 × 28 in? Route it on our CNC.',
      body: [
        'Our laser cuts sheets up to 40 × 28 in and acrylic or wood up to 1/4 in thick. For thicker stock, full sheets, aluminum or 3D carving, our CNC router takes material up to 5 × 10 ft, in the same studios.',
      ],
      link: { to: facts.paths.cncLarge, text: 'Large-format CNC routing' },
    },
    stepsTitle: 'How does laser cutting in NYC work with us?',
    steps: [
      laserSteps[0],
      laserSteps[1],
      laserSteps[2],
      {
        title: 'Collect it, or we send it',
        body: 'Pick up by appointment in Glendale, Queens or Brooklyn, send a courier to collect, or have the parts packed and shipped.',
      },
    ],
    optionsTitle: 'Where can you get laser cutting near you in NYC?',
    options: [
      {
        label: 'O1',
        title: 'A makerspace or school laser',
        body: 'Some New York makerspaces and schools rent laser time after a short class. Cheapest for a few small parts, if the bed size and the booking wait work for you.',
      },
      {
        label: 'O2',
        title: 'An instant-quote website',
        body: 'Upload a file, pick a stock material and wait for the parts to ship. Fine for standard flat parts; no drop-off, and file help is rarely included.',
      },
      {
        label: 'O3',
        title: 'A laser cutting studio in NYC, like ours',
        body: 'A person checks the file and the material, cuts, scores and engraves in one job, and quotes before cutting. Drop off and collect by appointment in Queens or Brooklyn.',
      },
    ],
    fit: {
      good: [
        'Architectural models for firms and students: chipboard, museum board, basswood, acrylic',
        'Acrylic signs, letters, displays and event pieces for NYC brands and agencies',
        'Parts for art installations and gallery shows',
        'Flat prototypes, enclosures, stencils and layered pieces',
        'Short runs of the same part, cut and engraved',
      ],
      other: [
        'Running the laser yourself: a makerspace rents laser time',
        'Cutting steel or other sheet metal: a metal fabrication shop',
        'A single cheap hobby piece: a makerspace or online marketplace costs less',
        'Stock over 1/4 in thick or bigger than 40 × 28 in: our CNC routing',
      ],
    },
    pricingTitle: 'How much does laser cutting cost in NYC?',
    pricingLabel: 'Laser cutting in NYC',
    prices: [
      ['Laser cutting and engraving', 'Quoted per project'],
      ['Sheet material', 'We source it, or you drop it off'],
      ['File preparation from a sketch', 'Quoted per project'],
      ['Courier or shipping', 'Quoted to your address'],
    ],
    pricingNote:
      'The price depends on the material and thickness, how many sheets the parts need, cutting and engraving time, file preparation, quantity and your date. Send the file and we’ll reply with a price; it costs nothing to ask.',
    reviews: 'laser-cutting',
    handoffEyebrow: 'NYC drop-off & pickup',
    handoffTitle: 'Laser cutting in Brooklyn and Queens: our studios',
    handoff:
      'Wherever you are in the five boroughs, drop off approved material and collect your parts by appointment at the studio named in your quote, or send a courier. Visits are by appointment only, so send the file first and confirm a time before you come.',
    timingTitle: 'Have a deadline?',
    timing:
      'Turnaround depends on the file, material, quantity and finishing, so your quote confirms the date. For a review deadline or crit, tell us the day you need the parts; rush work is reviewed job by job, and same-day cutting isn’t standard.',
    faqTitle: 'What do New Yorkers ask about laser cutting?',
    faqs: [
      {
        question: 'Where can I get laser cutting done in NYC?',
        answer:
          'You can rent time on a makerspace laser, use an instant-quote website, or send the job to a laser cutting studio. PrintAWorld cuts acrylic, wood, paper and card in-house on a 40 × 28 inch Epilog laser, with studios in Glendale, Queens and Brooklyn. Send your file, get a written quote, then collect by appointment, send a courier, or have it shipped.',
      },
      {
        question:
          'Is there a laser cutting service near me in Brooklyn or Queens?',
        answer:
          'Yes. PrintAWorld has two studios: 616 Berriman Street in Brooklyn and 74-12 88th Street in Glendale, Queens. Visits are by appointment, so send your file first; the quote names the studio and you confirm a time before you come.',
      },
      {
        question: 'How much does laser cutting cost in NYC?',
        answer:
          'At PrintAWorld, laser cutting is quoted per project. The material and thickness, number of sheets, cutting and engraving time, file preparation, quantity and deadline set the price. Send the file with the material and quantity, and a person replies with a written price.',
      },
      {
        question: 'Can I drop off my own material?',
        answer:
          'Yes, once we approve it. Send the exact product, thickness and a link or photo first. We confirm in writing that it can be cut safely, then you drop it off by appointment or send it by courier.',
      },
      {
        question: 'Can architecture students send model files?',
        answer:
          'Yes. Send the vector file with layers for cut, score and engrave, the material (chipboard, museum board, basswood or acrylic) and your review date. Every job gets the same review and written quote, and we tell you if a part won’t fit on the 40 × 28 inch bed.',
      },
      {
        question: 'How fast can you laser cut in NYC?',
        answer:
          'Your written quote confirms the date, based on the file, material and quantity. Tell us your deadline when you ask. Rush work is reviewed job by job, and same-day cutting isn’t standard.',
      },
      {
        question: 'Can I rent your laser cutter or cut it myself?',
        answer:
          'No, we cut your parts for you; we don’t rent machine time. If you want to run a laser yourself, a New York makerspace that rents laser time is the better fit.',
      },
      {
        question: 'How thick and how big can you cut?',
        answer:
          'Acrylic and wood up to 1/4 inch thick, on a 40 × 28 inch bed. The usable area depends on the sheet and the design. Bigger or thicker parts go on our CNC router, which takes stock up to 5 × 10 feet.',
      },
      {
        question: 'Can you laser cut metal in NYC?',
        answer:
          'Our laser doesn’t cut steel or other sheet metal; a metal fabrication shop is the better fit for that. Aluminum parts can be reviewed for our CNC router, and logos on metal objects go through our metal engraving service.',
      },
      {
        question: 'Do you ship outside New York?',
        answer:
          'Yes, anywhere in the U.S. We pack the parts flat and quote shipping to your ZIP code with the job.',
      },
    ],
    quoteTitle: ['Send us your file.', 'We’ll send a price.'],
    quoteIntro:
      'You don’t need to know laser settings. Send the file, the material and how many you need, and we’ll reply with a price, the studio and a pickup time.',
    checklist: [
      'Vector file (AI, SVG, EPS, DWG, DXF or 3DM), at full size',
      'Material, color and thickness',
      'Finished size and quantity',
      'Which lines cut, score or engrave',
      'Your own material, or should we source it?',
      'Deadline, and pickup, courier or shipping',
    ],
    related: [
      [facts.paths.laser, 'All laser cutting'],
      [facts.paths.cncLarge, 'Large-format CNC, 5 × 10 ft'],
      [facts.paths.cnc, 'CNC routing'],
      ['/laser-engraving-service-nyc/', 'Laser engraving in NYC'],
    ],
    planner: 'laser',
  },

  cnc: {
    path: facts.paths.cnc,
    crumb: 'CNC routing',
    serviceName: 'CNC routing and milling services',
    serviceType: 'CNC routing, milling, cutting, carving and engraving',
    title: 'CNC Routing and Milling Services | Signs, Panels, Props',
    description:
      'CNC routing and milling for signs, wall panels, furniture parts, props and relief carving. Wood, MDF, foam, plastics and aluminum on a 5 × 10 ft bed.',
    eyebrow: 'CNC routing service · Cut in New York, shipped across the U.S.',
    heading: 'CNC Routing and Milling Services',
    answer:
      'PrintAWorld is a CNC routing service for signs, art, furniture parts, props, architectural and interior pieces, relief carvings and wall panels. Our CNC router takes stock up to 5 × 10 feet and cuts, pockets, carves and engraves wood, MDF, plastics, high-density urethane foam, laminate and aluminum. Send an STP or vector file and a person reviews it and confirms price and timing. We ship anywhere in the U.S., or you pick up in New York.',
    hero: 'window',
    reviewedDate,
    introEyebrow: 'CNC routing',
    introTitle: 'What is CNC routing?',
    intro: [
      'CNC stands for computer numerical control. A CNC router is a computer-guided cutting spindle that moves over a flat bed and cuts, pockets, carves or engraves sheet and block material from your CAD file. It’s mostly used on wood, plastics, foam and composites, plus non-ferrous metals such as aluminum.',
      'With us, a person reviews every job: the file, the material, hold-down and tooling. We tell you what needs changing and quote before anything is cut. Need a 3D model first? We can model it from an image or reference.',
    ],
    glanceTitle: 'Our CNC routing service at a glance',
    glance: [
      [
        'Bed size',
        'Stock up to 5 × 10 ft. The usable area depends on the material, hold-down and tooling.',
      ],
      ['Operations', 'Cutting, pocketing, 3D carving and engraving'],
      [
        'Materials',
        'Wood, MDF, plastics, high-density urethane (HDU) foam board, high-pressure laminate and aluminum',
      ],
      ['Files', facts.cnc.files],
      [
        'No file?',
        `3D modeling from an image or reference, from $${facts.modelingFrom}`,
      ],
      ['Common projects', cncUses.join(', ')],
      [
        'Delivery',
        'Pickup by appointment in New York, or shipping anywhere in the U.S.',
      ],
      ...studioRows,
      ['Thin sheet, fine detail?', 'Laser cutting on a 40 × 28 in bed'],
    ],
    workTitle: 'CNC routing projects from our studio.',
    work: ['boatHouseEntry', 'boatHouseSide', 'panelArt'],
    materialsTitle: 'Which materials can we CNC route?',
    materials: cncMaterials,
    materialsNote:
      'Need something else? Tell us the exact material, grade and thickness. Every material is reviewed for tooling and hold-down before we quote.',
    uses: cncUses,
    usesTitle: 'What can CNC routing be used to make?',
    contrast: {
      eyebrow: 'Thin sheet, fine detail?',
      title: 'Card, thin acrylic or fine detail? Laser cut it.',
      body: [
        'For paper, card, museum board and acrylic or wood up to 1/4 in thick, our laser cutter gives fine detail and clean edges on a 40 × 28 in bed, and can score and engrave in the same run.',
      ],
      link: { to: facts.paths.laser, text: 'Explore laser cutting' },
    },
    stepsTitle: 'How does a CNC routing project move into production?',
    steps: cncSteps,
    optionsTitle: 'Where can you get CNC routing done?',
    options: [
      {
        label: 'O1',
        title: 'A makerspace or woodshop',
        body: 'Some makerspaces have a CNC router you can use after training. Fine for small parts if you can prepare toolpaths yourself.',
      },
      {
        label: 'O2',
        title: 'An online sheet-cutting service',
        body: 'Upload a 2D file, pick a stock sheet and wait for shipping. Good for standard flat parts; 3D carving, finishing and odd materials are usually out.',
      },
      {
        label: 'O3',
        title: 'A fabrication studio, like ours',
        body: 'A person checks the file, material and tooling, can model the part, and routes signs, panels, carvings and props on a 5 × 10 ft bed.',
      },
    ],
    fit: {
      good: [
        'Signs and dimensional letters in HDU foam, MDF or plastics',
        'Decorative wall panels and relief carvings',
        'Furniture parts and architectural or interior pieces',
        'Props, displays and parts for art fabrication',
        'Architectural model bases and large model parts',
      ],
      other: [
        'Tight-tolerance steel or 5-axis machined parts: a precision machine shop',
        'Paper, card or thin acrylic with fine detail: our laser cutting',
        'A single hobby cut you can do yourself: a makerspace router costs less',
      ],
    },
    pricingTitle: 'How much does CNC routing cost?',
    pricingLabel: 'CNC routing',
    prices: [
      ['CNC routing and carving', 'Quoted per project'],
      ['Material', 'We source it, or you supply it'],
      ['3D modeling from an image or reference', `From $${facts.modelingFrom}`],
      ['Finishing (sanding, paint)', 'Quoted per project'],
    ],
    pricingNote:
      'The price depends on the material and thickness, size, quantity, machining time, tooling, any modeling, finishing, packing, delivery and your date. Send your file and we’ll reply with a price; it costs nothing to ask.',
    handoffEyebrow: 'Shipping & pickup',
    handoffTitle: 'Where can you get your CNC-routed parts?',
    handoff:
      'We route in-house in New York and ship anywhere in the U.S., packed for the parts. Large pieces are quoted for crating and freight to your ZIP. In the city, pick up by appointment at the studio named in your quote.',
    timingTitle: 'Start with your date.',
    timing:
      'CNC time depends on the files, material, size, quantity, machining details and finish, so your written quote confirms the schedule. Tell us your in-hand date when you ask.',
    faqTitle: 'What do people ask about CNC routing?',
    faqs: [
      {
        question: 'How much does CNC routing cost?',
        answer: `CNC routing is quoted per project. The material and thickness, size, quantity, machining time, tooling, finishing and deadline set the price. If you need a 3D model made first, 3D modeling starts at $${facts.modelingFrom}. Send your file with the material and quantity, and a person replies with a written price.`,
      },
      {
        question: 'What materials can you CNC route?',
        answer:
          'Wood, plywood, MDF, plastics, high-density urethane (HDU) foam board, high-pressure laminate and aluminum. Every material is reviewed for grade, thickness, hold-down and tooling before we quote.',
      },
      {
        question: 'How big is your CNC router?',
        answer:
          'Our CNC bed takes stock up to 5 × 10 feet. The usable area depends on the material, thickness, hold-down and tooling, so we confirm the fit in your quote.',
      },
      {
        question: 'What file do I need for CNC routing?',
        answer:
          'For 3D carving, export an STP (STEP) file from software such as SolidWorks or Fusion 360. For 2D cutouts, a vector file from Adobe Illustrator (AI) or a DXF works. If you only have an image or reference, we can model it first.',
      },
      {
        question: 'What does CNC router mean?',
        answer:
          'CNC stands for computer numerical control. A CNC router is a computer-guided cutting machine in the CNC machining family, used mostly to cut and carve wood, plastics, foam and composites, as well as non-ferrous metals such as aluminum.',
      },
      {
        question: 'Should I use CNC routing or laser cutting?',
        answer:
          'Use laser cutting for paper, card and acrylic or wood up to 1/4 inch thick that fits a 40 × 28 inch bed, especially fine detail. Use CNC routing for thicker stock, full sheets up to 5 × 10 feet, aluminum, foam and 3D carving. Send the file and we’ll suggest the machine.',
      },
      {
        question: 'Can you CNC route aluminum?',
        answer:
          'Yes, reviewed aluminum. Send the grade, thickness and the features you need; we confirm tooling, hold-down and finish in the quote. For tight-tolerance steel parts, a precision machine shop is the better fit.',
      },
      {
        question: 'How long does CNC routing take?',
        answer:
          'Machining time depends on the material, complexity and size, and the full schedule includes review, material and finishing. Your written quote confirms the date; tell us your deadline when you ask.',
      },
      {
        question: 'Do you ship CNC-routed parts?',
        answer:
          'Yes, anywhere in the U.S. Shipping or freight is quoted to your ZIP code with the job. In New York you can pick up by appointment in Glendale, Queens or Brooklyn.',
      },
    ],
    quoteTitle: ['Send us your CAD file.', 'We’ll send a price.'],
    quoteIntro:
      'You don’t need toolpaths. Send the STP or vector file, or an image to model from, the material and how many you need, and we’ll reply with a price and next steps.',
    checklist: [
      'STP file for 3D carving, or an AI or DXF vector for 2D cuts',
      'Material, grade and thickness',
      'Finished size and quantity',
      'Cutting, pocketing, carving or engraving details',
      'Edge and surface finish',
      'Deadline and delivery ZIP code',
    ],
    related: [
      [facts.paths.cncLarge, 'Large-format CNC, 5 × 10 ft'],
      [facts.paths.laser, 'Laser cutting'],
      [facts.paths.laserNyc, 'Laser cutting in NYC'],
      ['/services/laser-engraving/', 'Laser engraving'],
    ],
    planner: 'cnc',
  },

  cncLarge: {
    path: facts.paths.cncLarge,
    crumb: 'Large-format CNC',
    parent: 'cnc',
    serviceName: 'Large-format CNC routing and 3D wood carving',
    serviceType: 'CNC routing, 3D carving, cutting and engraving',
    title: 'CNC Routing Service & 3D Wood Carving | 5 × 10 ft Bed',
    description:
      'Large-format CNC routing and 3D wood carving on a 5 × 10 ft bed: MDF, plywood, HDU sign foam, plastics and aluminum. Quoted from your STP or vector file.',
    eyebrow: 'Large-format CNC router · 5 × 10 ft bed · New York',
    heading: 'CNC Routing Service with a 5 × 10 ft Bed',
    answer:
      'Large-format CNC routing and 3D wood carving on a 5 × 10 ft bed. PrintAWorld routes full sheets of wood, MDF, plastics, laminate, aluminum and high-density urethane sign foam, and carves 3D reliefs from STP files, for signs, wall panels, props, displays and architectural models. A person reviews every file before quoting. Pick up by appointment at our Queens or Brooklyn studio, or we ship across the U.S.',
    hero: 'boatHouseSide',
    reviewedDate,
    introEyebrow: 'Large-format CNC',
    introTitle: 'What can a 5 × 10 ft CNC router make?',
    intro: [
      'A bed that takes stock up to 5 × 10 feet lets us cut full sheets in one setup: large signs and letters, wall panels, furniture and interior parts, props and display pieces, and the contoured bases of architectural models.',
      'The same router carves in 3D. From an STP file we rough and finish reliefs, carved signs and sculptural surfaces in wood, MDF and high-density urethane (HDU) foam. A person reviews the file, hold-down and tooling before we quote.',
    ],
    glanceTitle: 'Large-format CNC routing at a glance',
    glance: [
      [
        'Bed size',
        'Stock up to 5 × 10 ft. The usable area depends on the material, hold-down and tooling.',
      ],
      ['Operations', '2D cutting, pocketing, 3D carving and engraving'],
      ['3D wood carving', 'Reliefs and carved surfaces from an STP file'],
      [
        'Materials',
        'Wood, MDF, plastics, high-density urethane (HDU) foam board, high-pressure laminate and aluminum',
      ],
      ['Files', facts.cnc.files],
      [
        'No file?',
        `3D modeling from an image or reference, from $${facts.modelingFrom}`,
      ],
      ['Common projects', cncUses.join(', ')],
      [
        'Pickup & delivery',
        'Pickup by appointment, or crated shipping anywhere in the U.S.',
      ],
      ...studioRows,
    ],
    workTitle: 'Large-format CNC work from our studio.',
    work: ['boatHouse', 'window', 'panelArt'],
    materialsTitle: 'Which materials go on the 5 × 10 ft bed?',
    materials: cncMaterials,
    materialsNote:
      'Bringing your own sheets or foam blocks? Send the exact product, grade and thickness first; we confirm tooling and hold-down in writing before you deliver it.',
    uses: cncUses,
    usesTitle: 'What do clients use our CNC routing service for?',
    contrast: {
      eyebrow: 'Thin sheet, fine detail?',
      title: 'Card, thin acrylic or fine detail? Laser cut it.',
      body: [
        'For paper, card, museum board and acrylic or wood up to 1/4 in thick, our laser cutter gives fine detail on a 40 × 28 in bed, in the same New York studios.',
      ],
      link: { to: facts.paths.laserNyc, text: 'Laser cutting in NYC' },
    },
    stepsTitle: 'How does a large-format CNC project work?',
    steps: cncSteps,
    fit: {
      good: [
        'Full-sheet signs, letters and panels up to 5 × 10 ft',
        '3D wood carving and relief carving in wood, MDF or HDU foam',
        'Carved HDU foam signs and props',
        'Furniture, interior and architectural parts',
        'Architectural model bases and large model parts',
      ],
      other: [
        'Tight-tolerance steel or 5-axis machined parts: a precision machine shop',
        'Paper, card or thin acrylic with fine detail: our laser cutting',
        'A single small cut you can do yourself: a makerspace router costs less',
      ],
    },
    fitTitle: 'Is large-format CNC routing right for your project?',
    pricingTitle: 'How much does large-format CNC routing cost?',
    pricingLabel: 'Large-format CNC',
    prices: [
      ['CNC routing and 3D carving', 'Quoted per project'],
      ['Material and full sheets', 'We source it, or you supply it'],
      ['3D modeling from an image or reference', `From $${facts.modelingFrom}`],
      ['Crating and freight', 'Quoted to your ZIP'],
    ],
    pricingNote:
      'The price depends on the material, sheet count and thickness, machining and carving time, tooling, any modeling, finishing, crating, delivery and your date. Send your file and we’ll reply with a price; it costs nothing to ask.',
    handoffEyebrow: 'Pickup & freight',
    handoffTitle: 'Getting large CNC parts to you',
    handoff:
      'Big parts need a plan. Pick up by appointment at the studio named in your quote, in Glendale, Queens or Brooklyn, or we crate the parts and quote freight to your ZIP code anywhere in the U.S.',
    timingTitle: 'Start with your date.',
    timing:
      'Machining time depends on the material, size, carving depth and quantity, so your written quote confirms the schedule. Tell us your install or event date when you ask.',
    faqTitle: 'Questions about large-format CNC routing.',
    faqs: [
      {
        question: 'How big is your CNC bed?',
        answer:
          'Our CNC router takes stock up to 5 × 10 feet, so a standard 4 × 8 ft sheet fits. The usable cut area depends on the material, thickness, hold-down and tooling; we confirm the fit in your quote.',
      },
      {
        question: 'Do you offer 3D wood carving?',
        answer:
          'Yes. We carve reliefs, carved signs and sculptural surfaces in wood, MDF and high-density urethane foam from an STP (STEP) file. If you only have an image, we can model it first; 3D modeling starts at $250.',
      },
      {
        question: 'Can you carve HDU foam signs?',
        answer:
          'Yes. High-density urethane (HDU) foam board is one of our standard CNC materials for carved and dimensional signs and props. Tell us the thickness, finish and whether the sign goes indoors or outdoors.',
      },
      {
        question: 'Do you CNC route architectural models?',
        answer:
          'Yes: contoured site bases, large model parts and panels, like the boat house model shown here. For fine card or thin acrylic parts, we laser cut them in the same studios.',
      },
      {
        question: 'What materials can go on the 5 × 10 ft bed?',
        answer:
          'Wood, plywood, MDF, plastics, high-density urethane foam board, high-pressure laminate and aluminum. We review the grade, thickness and tooling before quoting.',
      },
      {
        question: 'How much does large-format CNC routing cost?',
        answer:
          'It’s quoted per project. Sheet count and thickness, machining and carving time, tooling, finishing, crating and your deadline set the price. Send your file with the material and quantity, and a person replies with a written price.',
      },
      {
        question: 'How long does a CNC project take?',
        answer:
          'Machining time depends on the material, size, carving depth and quantity, and the schedule also covers review, material and finishing. Your written quote confirms the date.',
      },
      {
        question: 'Can you deliver large CNC parts?',
        answer:
          'Yes. Pick up by appointment in Glendale, Queens or Brooklyn, or we crate the parts and quote freight to your ZIP code anywhere in the U.S.',
      },
    ],
    quoteTitle: ['Send us your CAD file.', 'We’ll send a price.'],
    quoteIntro:
      'You don’t need toolpaths. Send the STP or vector file, or an image to model from, the material and how many you need, and we’ll reply with a price and next steps.',
    checklist: [
      'STP file for 3D carving, or an AI or DXF vector for 2D cuts',
      'Material, grade and thickness',
      'Finished size and quantity',
      'Cutting, pocketing, carving or engraving details',
      'Finish, and indoor or outdoor use',
      'Deadline and delivery ZIP code',
    ],
    related: [
      [facts.paths.cnc, 'All CNC routing'],
      [facts.paths.laserNyc, 'Laser cutting in NYC'],
      [facts.paths.laser, 'Laser cutting'],
      ['/services/laser-engraving/', 'Laser engraving'],
    ],
    planner: 'cnc',
  },
}

module.exports = { facts, photos, pages, reviewedDate }
